
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/movemeout/privacy-policy",
      function () {
        return require("private-next-pages/movemeout/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/movemeout/privacy-policy"])
      });
    }
  